import { PluginReview, PluginWorkSite } from 'rwl-shared/dist/models';

export const findReview = (job?: PluginWorkSite): PluginReview | undefined => {
    if (!job) {
        return undefined;
    }
    const reviews: PluginReview[] = job.content.filter(
        (review) => review.type === 'Review'
    ) as PluginReview[];

    if (reviews.length === 1) {
        return reviews[0];
    }
    if (reviews.length === 0) {
        return undefined;
    }

    const googleReview = reviews.find((review) => review.source === 'GMB');
    if (googleReview) {
        return googleReview;
    }

    const facebookReview = reviews.find(
        (review) => review.source === 'Facebook'
    );
    if (facebookReview) {
        return facebookReview;
    }

    return reviews[0];
};
